import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './plugins/axios'
import router from './router'
import './registerServiceWorker'
import VueApexCharts from 'vue-apexcharts'
import './assets/styles/app.css'

Vue.component('ApexChart', VueApexCharts)

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
